import Styled from 'styled-components'

export default Styled.div`
  min-height: 0;
  height: 100%;
  padding: 3rem 1.5rem;
  overflow: auto;
`



// WEBPACK FOOTER //
// ./src/components/SidebarContent/index.js